import React, { useEffect, useState } from "react";
import { FiThumbsUp } from "react-icons/fi";
import { Link } from "react-router-dom";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../util/CustomPagination";
import { formatDuration, intervalToDuration } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Avatar, Tag } from "antd";
import AuthService from "../../../admin/components/login/AuthService";
import {Container, Row, Col, Card, CardBody} from "reactstrap";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
require("./assets/css/searchDuty.css");

const ListSearchDuty = ({ duties: initialDuties = [], loading, pagination, totalDuties, onPageChange, onSortChange }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [duties, setDuties] = useState(initialDuties); // Define o estado de duties

    useEffect(() => {
        if (AuthService.isAuthenticated()) {
            setIsAuthenticated(true);
        }
    }, []);

    useEffect(() => {
        setDuties(initialDuties);
    }, [initialDuties]);

    const handleInterestClick = (dutyId, hasInterest) => {
        const endpoint = hasInterest ? "duty/disable-interest" : "duty/accept";
        const action = hasInterest ? "cancelado" : "registrado";


        ApiService.send(
            hasInterest ? "delete" : "post",
            `${process.env.REACT_APP_URL_API}${endpoint}`,
            { id: dutyId },
            true
        )
            .then((res) => {

                Swal.fire({
                    title: "Sucesso",
                    text: `Manifestação de interesse ${action} com sucesso!`,
                    icon: "success",
                    confirmButtonText: "OK",
                });

                // Atualiza o estado dos duties corretamente
                setDuties((prevDuties) =>
                    prevDuties.map((duty) =>
                        duty.id === dutyId ? { ...duty, interest: hasInterest ? 0 : 1 } : duty
                    )
                );
            })
            .catch((error) => {
                if (error.response) {
                    let messageErro = "";

                    if (error.response.data.errors) {
                        messageErro = error.response.data.errors.join("<br/>");
                    }
                    Swal.fire({
                        title: "Erro",
                        text: `${error.response.data.message}`,
                        html: `${messageErro}`,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                } else {

                 }
            });
    };

    const calculateDuration = (start, end) => {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const duration = intervalToDuration({ start: startDate, end: endDate });
        return formatDuration(duration, { format: ["hours", "minutes"], locale: ptBR });
    };

    const options = [
        { value: "date_asc", label: "Data - Cresc" },
        { value: "date_desc", label: "Data - Desc" },
        { value: "value_desc", label: "Valor - Maior" },
        { value: "value_asc", label: "Valor - Menor" },
        { value: "distance_asc", label: "Km - Menor" },
    ];

    const handleSortChange = (selectedOption) => {
        onSortChange(selectedOption.value); // Envia o valor de ordenação selecionado para o componente pai
    };

    return (
        <div className="container py-4">
            {isLoading && <LoadingScreen />}
            <div className="doctor-filter-info mb-4">
                <div className="doctor-filter-inner d-flex justify-content-between align-items-center">
                    <div>
                        <p className="mb-0 text-primary">
                            <strong>{pagination.total}</strong> Plantões encontrados
                        </p>
                    </div>
                    <div className="d-flex align-items-center">
                        <p className="mb-0 me-2">Por:</p>
                        <div className="doctor-filter-select w-100">
                            <Select
                                className="select w-100"
                                defaultValue={options.find((option) => option.value === "date_asc")}
                                options={options}
                                placeholder="Selecione a ordenação"
                                isSearchable={false}
                                onChange={handleSortChange} // Adiciona o evento de mudança
                                menuPortalTarget={document.body} // Renderizar o menu fora do contêiner
                                styles={{
                                    container: (provided) => ({ ...provided, flex: 1 }),
                                    control: (provided) => ({ ...provided, minHeight: "38px" }),
                                    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }), // Define z-index alto
                                    menu: (provided) => ({ ...provided, zIndex: 9999 }), // Ajusta o z-index no menu
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="row">
                    {[...Array(2)].map((_, index) => (
                        <div key={index} className="col-12 mb-4">
                            <div className="card shadow-sm">
                                <Skeleton height={150} />
                                <div className="card-body">
                                    <Skeleton width={100} height={24} />
                                    <Skeleton className="mt-2" width="80%" />
                                    <Skeleton className="mt-2" width="60%" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : duties.length > 0 ? (
                <div className="row">
                    {duties.map((duty) => (
                        <Col lg={12} key={duty.id}>
                            <Card className="mb-2 p-1 shadow-sm card-hover duty-card" key={duty.id}>
                                <CardBody
                                    className="p-2 d-flex justify-content-between align-items-start">
                                    <div className="col-10 d-flex">

                                        <img
                                            src={duty.hospital?.images[0]?.file || process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"}
                                            alt={duty.hospital?.name || "Local"}
                                            style={{width: 60, height: 60, objectFit: "cover"}}
                                            className="rounded me-3"
                                        />
                                        <div className="w-100">
                                            <h6 className="mb-1"
                                                style={{fontSize: "0.95rem"}}>{duty.hospital?.name}</h6>
                                            <p className="mb-1"
                                               style={{fontSize: "0.8rem"}}>
                                                <i className="fa fa-map-marker text-info me-1"></i>
                                                {duty.hospital?.city?.name}, {duty.hospital?.uf} &nbsp;
                                                {duty.department?.name && (
                                                    <><i
                                                        className="fa fa-building text-info me-1"></i>{duty.department.name}</>
                                                )}
                                            </p>
                                            <p className="mb-1"
                                               style={{fontSize: "0.8rem"}}>
                                                <i className="fa fa-hourglass text-info me-1"
                                                   aria-hidden="true"></i>
                                                {calculateDuration(duty.date_time, duty.date_time_end)}
                                            </p>
                                            <div>
                                                {duty.specialties?.map((s) => (
                                                    <Tag key={s.id} color="blue"
                                                         style={{fontSize: "0.75rem"}}>{s.name}</Tag>
                                                ))}
                                            </div>
                                            <p className="text-muted mb-1">
                                                <i className="fa fa-calendar text-info"
                                                   style={{marginRight: "8px"}}></i>
                                                {new Date(duty.date_time).toLocaleDateString("pt-BR")}{" "}
                                                {new Date(duty.date_time).toLocaleTimeString("pt-BR", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                })}
                                                &nbsp;&nbsp;&nbsp;&nbsp;

                                                {new Date(duty.date_time_end).toLocaleDateString("pt-BR")}{" "}
                                                {new Date(duty.date_time_end).toLocaleTimeString("pt-BR", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                })}
                                            </p>
                                            {duty.observation && (
                                                <p className="text-muted mt-1"
                                                   style={{fontSize: "0.75rem"}}>
                                                    <i className="far fa-file-alt text-info me-1"></i>
                                                    {duty.observation.length > 60 ? `${duty.observation.slice(0, 60)}...` : duty.observation}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-2 text-end">

                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <Avatar
                                                src={duty.user?.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                size={45}
                                                className="me-2"
                                            />
                                            <div className="text-end">
                                                {duty.user?.name || "Usuário não especificado"}
                                            </div>
                                        </div>
                                        <p className="text-success fs-5 mb-2">
                                            {new Intl.NumberFormat("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                            }).format(duty.value)}
                                        </p>
                                        <div className="clinic-booking">

                                            {duty.interest === 1 ? (
                                                <button type="button"
                                                    className="btn btn-sm btn-danger "
                                                    onClick={() => handleInterestClick(duty.id, true)}
                                                >
                                                    <i className="fa fa-minus"></i> Cancelar Interesse
                                                </button>
                                            ) : (
                                                <button type="button"
                                                    className="btn btn-sm btn-info  btn-interest mt-2"
                                                    onClick={() => handleInterestClick(duty.id, false)}
                                                >
                                                    <i className="fa fa-plus"></i> Cadastrar Interesse
                                                </button>
                                            )}

                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}


                    <div className="load-more text-center mt-4">
                        <CustomPagination pagination={pagination}
                                          onChange={onPageChange}/>
                    </div>
                </div>
            ) : (
                <div className="text-center">
                    <p className="text-muted">Não foram encontrados plantões disponíveis.</p>
                </div>
            )}


        </div>
    );
};

export default ListSearchDuty;
